import Vue from "vue"
import getScrollBarWidth from "../utils/scrollbar-width"
import { getTarget } from "../utils/helper"

const HIDDEN_CLASS = "mm-scrollbar--hidden"

if (!Vue.prototype.$isServer) {
  const sheet = (() => {
    const style = document.createElement("style")
    style.appendChild(document.createTextNode(""))
    document.head.appendChild(style)
    return style.sheet
  })()

  sheet.insertRule(`.${HIDDEN_CLASS} { overflow: hidden; }`, 0)
}

export default {
  props: {
    lockScroll: {
      type: Boolean,
      default: true,
    },
    target: null,
  },
  methods: {
    addScrollEffect() {
      if (this.$isServer) {
        return
      }
      const targetNode = getTarget(this.target)

      if (!targetNode || !this.lockScroll) {
        return
      }

      this.withoutHiddenClass = !targetNode.classList.contains(HIDDEN_CLASS)

      if (this.withoutHiddenClass) {
        this.paddingRight = targetNode.style.paddingRight
        this.computedPaddingRight = parseInt(getComputedStyle(targetNode).paddingRight, 10)
      }

      const scrollBarWidth = getScrollBarWidth()

      targetNode.style.paddingRight = `${this.paddingRight + this.scrollBarWidth}px`

      const computedNode = targetNode === document.body ? document.documentElement : targetNode
      const HasOverflow = computedNode.clientHeight < targetNode.scrollHeight
      const overflowY = getComputedStyle(targetNode).overflowY
      if (
        scrollBarWidth > 0 &&
        (HasOverflow || overflowY === "scroll") &&
        this.withoutHiddenClass
      ) {
        targetNode.style.paddingRight = this.computedPaddingRight + scrollBarWidth + "px"
      }
      targetNode.classList.add(HIDDEN_CLASS)
    },
    removeScrollEffect() {
      if (this.$isServer) {
        return
      }
      const targetNode = getTarget(this.target)

      if (!targetNode || !this.lockScroll) {
        return
      }

      if (this.withoutHiddenClass) {
        targetNode.style.paddingRight = this.paddingRight
        targetNode.classList.remove(HIDDEN_CLASS)
      }
    },
  },
}
